export const brushStyles = {
  handle: {
    cursor: 'col-resize',
    pointerEvents: 'none',
    strokeWidth: 4,
  },
  brushHandleAccent: {
    cursor: 'col-resize',
    pointerEvents: 'none',
    strokeWidth: 2,
    stroke: '#FFFFFF',
    opacity: 0.8,
  },
  labelGroup: {
    transition: 'opacity 300ms',
  },
  tooltipBackground: {
    fill: '#2C2F36', // theme.surface3 equivalent
  },
  tooltip: {
    textAnchor: 'middle',
    fontSize: '13px',
    fill: '#FFFFFF', // theme.neutral1 equivalent
  },
} as const;

// Constants
export const FLIP_HANDLE_THRESHOLD_PX = 20;
export const BRUSH_EXTENT_MARGIN_PX = 2;
